<template>
  <div id="search" :class="{ active: isOpen, 'search-page': isSearchPage }">
    <b-btn v-if="isOpen"class="btn-close" @click="onClose">
      <i class="material-icons">
        close
      </i>
      close
    </b-btn>
    <div class="search-inputs">
      <b-row v-click-outside="handleClickOutside">
        <b-col id="search-input" cols="12" :lg="isSearchPage ? 6 : 12" :class="{ 'mt-lg-2': isSearchPage }">
          <b-input-group>
            <b-input-group-text slot="prepend" :class="{ 'd-none': isSearchPage, 'd-md-flex': isSearchPage }">
              <i class="material-icons">search</i>
            </b-input-group-text>
            <div class="d-flex search-input-wrapper form-control">
              <div v-if="isSearchPage" id="language-block" class="language-select d-block d-sm-inline-block">
                <autocomplete-languages :isSearchPage="isSearchPage" @input="chooseLanguage"></autocomplete-languages>
              </div>
              <div id="search-block" class="autocomplete d-block d-sm-inline-block" @click="handleClickInside">
                <input v-model="searchi18n"
                       type="text"
                       id="search-services"
                       class="form-control"
                       :placeholder="$t('placeholders.searchInput')"
                       @keyup.down="onArrowDown"
                       @keyup.up="onArrowUp"
                       @keyup.enter="onEnter"
                       @input="onChange"
                       @click="openSuggestions"
                       autocomplete="off" />

                <div v-if="!_.isEmpty(specialitiesResultsi18n)"
                     id="autocomplete-specialities"
                     v-show="isOpen && (showSpecialities || searchi18n !== '')"
                     class="autocomplete-results autocomplete-specialities"
                     :class="{ 'full-width': !showServices }">
                  <div class="wrapper">
                    <ul class="suggestions-list">
                      <li>
                        <h6 class="mt-3 mb-3">{{ $t('labels.suggestedCategories') }}</h6>
                      </li>
                      <li class="loading" v-if="isLoading">
                        {{ $t('preloader.searchingResults') }}
                      </li>
                      <li v-else
                          v-for="(result, index) in specialitiesResultsi18n"
                          :key="index"
                          @click="setResult(index, 'specialities')"
                          class="autocomplete-result"
                          :class="{ 'is-active': index === arrowCounter }">
                        <strong>{{ result }}</strong>
                      </li>
                    </ul>
                  </div>

                  <b-btn v-if="isSearchPage && !showServices"
                         class="btn-browse-services"
                         @click.prevent="browseServices()">{{ $t('buttons.browseServices') }} &rarr;</b-btn>
                </div>

                <div v-if="!_.isEmpty(servicesResultsi18n)"
                     id="autocomplete-services"
                     v-show="isOpen && showServices"
                     class="autocomplete-results autocomplete-services">
                  <div class="wrapper">
                    <ul>
                      <li>
                        <h6 class="mt-3 mb-3">{{ $t('labels.suggestedServices') }}</h6>
                      </li>
                      <li class="loading" v-if="isLoading">
                        {{ $t('preloader.searchingResults') }}
                      </li>
                      <li v-else
                          v-for="(result, index) in servicesResultsi18n"
                          :key="index"
                          @click="setResult(index, 'services')"
                          class="autocomplete-result"
                          :class="{ 'is-active': index === arrowCounter }">
                        <strong>{{ result.mainKey }}</strong> - {{ result.subKey }}
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-else-if="_.isEmpty(servicesResultsi18n) && _.isEmpty(searchNamesResults) && showServices"
                     v-show="isOpen"
                     id="services-list"
                     class="autocomplete-results autocomplete-services">
                  <div class="wrapper">
                    <h6 class="mt-3 mb-3">{{ $t('labels.chooseService') }}</h6>
                    <ul v-if="!selectedMainLevel" class="suggestions-list">
                      <li class="autocomplete-result main-level"
                          :key="index"
                          v-for="(service, index) in servicesArray"
                          @click="selectMainLevel(service.id)">
                        {{ $t(`services.${service.id}`) }}
                        <i class="material-icons">
                          keyboard_arrow_right
                        </i>
                      </li>
                    </ul>
                    <div v-else class="mb-3">
                      <b-btn @click="disselectMainLevel" class="btn-back">
                        <i class="material-icons">
                          keyboard_arrow_left
                        </i>
                        <span>{{ $t('buttons.back') }}</span>
                      </b-btn>

                      <h6 class="selected-main-level mt-3 mb-3">{{ $t('labels.selectedMainService') }}:<div>{{ $t(`services.${selectedMainLevel}`) }}</div></h6>

                      <div class="mb-3">{{ $t('labels.chooseSubService') }}:</div>
                      <div class="third-level">
                        <ul v-if="!_.isEmpty(subServices(selectedMainLevel))"
                            class="suggestions-list">
                          <li class="autocomplete-result"
                              :key="index"
                              v-for="(service, index) in subServices(selectedMainLevel)"
                              @click="addToSearch(selectedMainLevel, service.id)">
                            <strong>{{ $t(`services.${service.id}`) }}</strong>
                          </li>
                        </ul>
                      </div>

                      <b-btn @click="disselectMainLevel" class="btn-back">
                        <i class="material-icons">
                          keyboard_arrow_left
                        </i>
                        <span>{{ $t('buttons.back') }}</span>
                      </b-btn>
                    </div>
                  </div>
                </div>

                <div id="autocomplete-professionals"
                     v-if="!isSearchPage && _.isEmpty(servicesResultsi18n) && _.isEmpty(specialitiesResultsi18n) && !_.isEmpty(searchNamesResults)"
                     v-show="isOpen"
                     class="autocomplete-results autocomplete-professionals">
                  <div class="wrapper">
                    <ul class="suggestions-list">
                      <li>
                        <h6 class="mt-3 mb-3">{{ $t('labels.suggestedProfessionals') }}</h6>
                      </li>
                      <li class="loading" v-if="isLoading">
                        {{ $t('preloader.loadingPros') }}
                      </li>
                      <li v-else
                          v-for="(result, index) in searchNamesResults"
                          :key="index"
                          class="autocomplete-result"
                          :class="{ 'is-active': index === arrowCounter }">
                        <router-link :to="{ name: `ProfessionalsSingle.${$i18n.i18next.language}`, params: { slug: result.slug } }">
                          <b-row>
                            <b-col cols="4" lg="3" class="photo-wrapper">
                              <avatar class="profile" size="70px" :userName="result.first_name+' '+result.last_name" :userImage="result.image"></avatar>
                            </b-col>
                            <b-col cols="8" lg="9" class="">
                              <div class="title">
                                <strong>{{ result.first_name }} {{ result.last_name }}</strong>
                                <ratings :rating="result.rating" :count="result.rating_count"></ratings>
                              </div>
                            </b-col>
                          </b-row>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
              <b-btn v-if="searchi18n.length > 0"
                     class="services-list btn-clear"
                     @click.prevent="clearInput"
                     v-b-tooltip.hover
                     :title="$t('buttons.clearSearch')">
                <i class="material-icons">
                  clear
                </i>
              </b-btn>
              <div v-else-if="isSearchPage" class="d-inline-block">
                <b-btn class="btn-browse-services d-none d-md-inline-block"
                     @click.prevent="browseServices()"
                     v-b-tooltip.hover
                     :title="$t('buttons.openServices')">{{ $t('buttons.browseServices') }}</b-btn>

                <b-btn class="btn-browse-services d-md-none"
                       @click.prevent="openSuggestions()"
                       v-b-tooltip.hover
                       :title="$t('buttons.openServices')">{{ $t('buttons.showSuggestions') }}</b-btn>
              </div>
            </div>
          </b-input-group>
        </b-col>
        <b-col cols="12" :lg="isSearchPage ? 6 : 12" id="training-method" class="mt-3" :class="{ 'mt-lg-0': isSearchPage }">
          <div class="wrapper d-block d-md-flex">
            <b-btn variant="secondary"
                   @click="chooseTrainingMethod('remote')"
                   class="training-method d-block w-100"
                   :class="{ active: trainingMethod === 'remote' }">
              <span class="material-icons">
                {{ $t('onlineServices.methods.remote.icon') }}
              </span>
              <div>{{ $t('onlineServices.methods.remote.title') }}</div>
            </b-btn>
            <b-btn variant="secondary"
                   @click="chooseTrainingMethod('live')"
                   class="training-method d-block w-100 mt-3 mt-md-0"
                   :class="{ active: trainingMethod === 'live' }">
              <span class="material-icons">
                {{ $t('onlineServices.methods.live.icon') }}
              </span>
              <div>{{ $t('onlineServices.methods.live.title') }}</div>
            </b-btn>
            <b-btn variant="secondary"
                   @click="chooseTrainingMethod('programs')"
                   class="training-method d-block w-100 mt-3 mt-md-0"
                   :class="{ active: trainingMethod === 'programs' }">
              <span class="material-icons">
                {{ $t('onlineServices.methods.programs.icon') }}
              </span>
              <div>{{ $t('onlineServices.methods.programs.title') }}</div>
            </b-btn>
          </div>
        </b-col>
      </b-row>

      <b-btn v-if="!isSearchPage"
             variant="primary"
             class="btn-cta mt-4"
             :to="{ name: `OnlineProfessionalsSearch.${$i18n.i18next.language}`, params: searchParams }">
        {{ $t('onlineServices.searchBtn') }}
      </b-btn>
    </div>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Avatar from '@/app/global/components/Avatar'
  import Autocomplete from '@/app/global/components/Autocomplete'
  import debounce from 'debounce'
  import { DEBOUNCE_TIMER } from '@/util/constants'
  import fz from 'fuzzaldrin-plus'
  import Fuse from 'fuse-js-latest'
  window.Fuse = Fuse
  import Ratings from '@/app/global/components/Ratings'
  import Preloader from '@/app/global/components/Preloader'
  import gmapsInit from '@/util/gmaps'
  import Multiselect from 'vue-multiselect'
  import AutocompleteLanguages from '@/app/global/components/AutocompleteLanguages'

  export default {
    name: 'search-online',
    props: {
      showResults: {
        type: Boolean,
        required: false,
        default: true
      },
      definedSearch: {
        type: String,
        required: false,
        default: ''
      },
      definedLocation: {
        type: String,
        required: false,
        default: ''
      },
      isSearchPage: {
        type: Boolean,
        required: false,
        default: false
      },
      geoLocation: {
        type: Object,
        required: false
      },
    },
    components: {
      Avatar,
      Autocomplete,
      Ratings,
      Preloader,
      Multiselect,
      AutocompleteLanguages
    },
    data() {
      return {
        errors: {},
        form: {
          services: {
            id: null
          }
        },
        testArray: [
          {
            label: "performanceImprovement",
            id: "performanceImprovement"
          },
          {
            label: "strengthAndMuscle",
            id: "strengthAndMuscle"
          }
        ],
        query: '',
        location: '',
        locationLat: '',
        locationLng: '',
        options: {
          shouldSort: true,
          includeScore: true,
          includeMatches: true,
          threshold: 0.1,
          location: 0,
          distance: 10000,
          maxPatternLength: 200,
          minMatchCharLength: 4,
          keys: [
            'displayName',
            'description',
            'fullTextSpecialities',
            'fullTextServices',
            'fullTextCertificates',
            'fullTextLocations'
          ]
        },
        fuse: null,
        search: '',
        searchi18n: '',
        searchSpecific: '',
        isResultsLoading: false,
        isOpen: false,
        showSpecialities: false,
        showServices: false,
        servicesResults: [],
        servicesResultsi18n: [],
        specialitiesResults: [],
        specialitiesResultsi18n: [],
        isLoading: false,
        arrowCounter: -1,
        selectedMainLevel: null,
        isService: false,
        language: '',
        trainingMethod: '',
        languages: [
          {
            name: 'en',
            label: 'English'
          },
          {
            name: 'fi',
            label: 'Finnish'
          }
        ]
      }
    },
    computed: {
      ...mapGetters({
        user: 'account/user',
        authenticated: 'account/authenticated',
        servicesArray: 'account/services',
        specialitiesArray: 'account/specialities',
        searchResults: 'professionals/searchResults',
        searchNamesResults: 'professionals/searchNamesResults',
        searchAdsResults: 'professionals/searchResultsAds'
      }),
      searchParams () {
        let obj = { search: '#', language: '#', method: '#' }

        if (this.searchi18n) {
          obj.search = this.searchi18n
        }

        if (this.language) {
          obj.language = this.language
        }

        if (this.trainingMethod) {
          obj.method = this.trainingMethod
        }

        return obj
      },
      searchParamsService () {
        let obj = { search: '#', language: '#', method: '#', service: true }

        if (this.searchi18n) {
          obj.search = this.searchi18n
        }

        if (this.language) {
          obj.language = this.language
        }

        if (this.trainingMethod) {
          obj.method = this.trainingMethod
        }

        return obj
      },
      geoLocationComp () {
        return this.geoLocation
      }
    },
    methods: {
      ...mapActions({
        getServices: 'account/getServices',
        getSpecialities: 'account/getSpecialities',
        searchProfessionals: 'professionals/searchOnlineProfessionals',
        searchProfessionalsNames: 'professionals/searchOnlineProfessionalsNames',
        searchProfessionalsService: 'professionals/searchOnlineProfessionalsService',
        searchBoostedProfessionals: 'professionals/searchOnlineBoostedProfessionals',
        searchAds: 'professionals/searchOnlineAds',
      }),
      subServices (mainKey) {
        let subServices = _.find(this.servicesArray, { id: mainKey })
        if (!_.isEmpty(subServices)) {
          if (!_.isEmpty(subServices.children)) {
            return subServices.children
          } else {
            return []
          }
        } else {
          return []
        }
      },
      chooseTrainingMethod (method) {
        this.trainingMethod = method
      },
      addToSearch (key1, key2) {
        if (!_.isEmpty(key1) && !_.isEmpty(key2)) {
          this.search = `${key1} - ${key2}`
          this.searchi18n = this.$i18n.t(`services.${key1}`) + ' - ' + this.$i18n.t(`services.${key2}`)
          // this.onInput()
          this.isOpen = false
          this.$emit('openSearch', this.isOpen)
          this.isService = true
          this.onInput()
          this.$router.push({ name: `OnlineProfessionalsSearch.${this.$i18n.i18next.language}`, params: this.searchParamsService})
          this.onClose()
        }
      },
      onInput: debounce(function () {
          // if (this.showResults !== true) {
          //   this.closePopover()
          // }
          this.submitSearch()
        }, DEBOUNCE_TIMER),
      onOpen (field) {
        this.isOpen = true
        this.showSpecialities = true
        this.$emit('openSearch', this.isOpen)
        this.filterResults()
        // this.onInput()

        // window.scrollTo(0, 0)
        // document.body.classList.add('darkside')

        // if (this.showResults || (!this.showResults && field === 'services')) {
        //   let parent = this
        //   let darkside = document.getElementById('darkside')
        //   if (_.isNil(darkside)) {
        //     var elem = document.createElement('div')
        //     elem.id = 'darkside'
        //     document.body.appendChild(elem)
        //
        //     elem.addEventListener('click', function () {
        //       parent.closePopover()
        //     }, false)
        //   }
        //
        //   this.showPopover = true
        // }
      },
      onClose (event) {
        this.isOpen = false
        this.showSpecialities = false
        this.$emit('openSearch', this.isOpen)

        // document.body.className = document.body.className.replace('darkside', '')

        // this.closePopover()

        // var noClose = 'input#searchInput.form-control'
        // if (!event.target.matches(noClose)) {
        //   this.showPopover = false
        // }
      },
      submitSearch () {
        let searchInput = this.searchi18n
        let languageInput = this.language
        let methodInput = this.trainingMethod

        let payload = {
          search: searchInput,
          language: languageInput,
          method: methodInput
        }

        if (this.locationLat && this.locationLng) {
          payload.lat = this.locationLat
          payload.lng = this.locationLng
        }

        payload.geoLocation = this.geoLocationComp

        if (this.isService) {
          this.searchProfessionalsService({context: this, payload: payload})
          this.isService = false
        } else {
          this.searchProfessionalsNames({context: this, payload: payload})
          this.searchProfessionals({context: this, payload: payload})
        }

        // Boosted/paid professionals
        this.searchBoostedProfessionals({context: this, payload: payload})

        // Paid ads
        payload.training = 'online'
        this.searchAds({context: this, payload: payload})
      },
      onChange () {
        this.showServices = false
        this.isOpen = true
        this.$emit('openSearch', this.isOpen)
        this.filterResults()
        if (this.searchi18n) {
          this.onInput()
          if (/\s/.test(this.searchi18n)) {
            this.showServices = true
          }
        }
      },
      openSuggestions () {
        this.isOpen = true
        this.showSpecialities = true
        this.$emit('openSearch', this.isOpen)
        this.filterResults()
      },
      openLocation () {
        this.showSpecialities = false
        this.showServices = false
      },
      filterResults () {
        this.servicesResults = []
        this.servicesResultsi18n = []

        let servicesArr = []
        let servicesArri18n = []
        let servicesSrc = this.servicesArray

        if (this.searchi18n === '') {
          this.servicesResults = []
          this.servicesResultsi18n = []
        } else {
          for (let i = 0; i < servicesSrc.length; i++) {
            let mainKey = servicesSrc[i]['id']
            let subLevelArr = servicesSrc[i]['children']

            if (subLevelArr.length > 0) {
              for (let i = 0; i < subLevelArr.length; i++) {
                let subKey = subLevelArr[i]['id']
                servicesArr.push({mainKey: mainKey, subKey: subKey})
                servicesArri18n.push({
                  mainKey: this.$i18n.t(`services.${mainKey}`),
                  subKey: this.$i18n.t(`services.${subKey}`)
                })
              }
            }
          }

          this.servicesResults = _.filter(servicesArr, item => {
            return item.subKey.indexOf(this.search) > -1
          })

          this.servicesResultsi18n = _.filter(servicesArri18n, item => {
            return item.subKey.toLowerCase().indexOf(this.searchi18n.toLowerCase()) > -1
          })

          if (_.isEmpty(this.servicesResultsi18n)) {
            this.servicesResultsi18n = []
          }
        }

        let specialitiesSrc = this.specialitiesArray
        let specialitiesArr = []
        let specialitiesArri18n = []
        let parent = this
        for (let i = 0; i < specialitiesSrc.length; i++) {
          specialitiesArr.push(specialitiesSrc[i]['label'])
          specialitiesArri18n.push(specialitiesSrc[i]['label'])
        }

        this.specialitiesResults = _.filter(specialitiesArr, item => {
          return item.indexOf(this.search) > -1
        })
        if (_.isEmpty(this.specialitiesResults)) {
          this.specialitiesResults = specialitiesArr
        }

        this.specialitiesResultsi18n = _.filter(specialitiesArri18n, item => {
          return item.toLowerCase().indexOf(this.searchi18n.toLowerCase()) > -1
        })
        if (_.isEmpty(this.specialitiesResultsi18n)) {
          this.specialitiesResultsi18n = specialitiesArri18n
        }
      },
      setResult (index, type) {
        switch (type) {
          case 'services':
            // this.search = `${this.servicesResults[index].mainKey} - ${this.servicesResults[index].subKey}`
            this.searchi18n = `${this.servicesResultsi18n[index].mainKey} - ${this.servicesResultsi18n[index].subKey}`
            // this.searchi18n = this.servicesResultsi18n[key].replace(/<\/?strong>/g, '')
            this.isOpen = false
            this.$emit('openSearch', this.isOpen)
            this.isService = true
            // this.$router.push({ name: `OnlineProfessionalsSearch.${this.$i18n.i18next.language}`, params: this.searchParamsService})
            break
          case 'specialities':
            this.searchi18n = `${this.specialitiesResultsi18n[index]}`
            this.isOpen = false
            this.$emit('openSearch', this.isOpen)
            // this.$router.push({ name: `OnlineProfessionalsSearch.${this.$i18n.i18next.language}`, params: this.searchParams})
            break
        }
        this.isOpen = false
        this.$emit('openSearch', this.isOpen)
        this.onChange()
        this.onClose()
      },
      onArrowDown (evt) {
        if (this.arrowCounter < this.servicesResults.length) {
          this.arrowCounter = this.arrowCounter + 1
        }
      },
      onArrowUp () {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1
        }
      },
      onEnter () {
        this.isOpen = false
        this.$emit('openSearch', this.isOpen)
        this.$router.push({ name: `OnlineProfessionalsSearch.${this.$i18n.i18next.language}`, params: this.searchParams})
        // this.searchi18n = this.servicesResults[this.arrowCounter]
        // this.isOpen = false
        // this.arrowCounter = -1;
      },
      handleClickOutside: function(e) {
        let classesStr = e.target.className || []
        if (!_.isEmpty(classesStr)) {
          if (classesStr.indexOf('btn-back') !== -1 || classesStr.indexOf('main-level') !== -1 || classesStr.indexOf('btn-browse-services') !== -1) {
            // Keep it open
          } else {
            this.showSpecialities = false
            this.isOpen = false
            this.$emit('openSearch', this.isOpen)
            this.arrowCounter = -1
          }
        }
      },
      handleClickInside: function(e) {

      },
      geolocate: function () {
        if(!!navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            let lat = position.coords.latitude
            let lng = position.coords.longitude

            // var geocoder = new google.maps.Geocoder()
            // var geolocate = new google.maps.LatLng(lat, lng)
            //
            // geocoder.geocode({'latLng': geolocate}, function(results, status) {
            //   if (status == google.maps.GeocoderStatus.OK) {
            //     var result
            //     if (results.length > 1) {
            //       result = results[1]
            //     } else {
            //       result = results[0]
            //     }
            //     //console.log(result);
            //     console.log(result.address_components[2].long_name + ', ' + result.address_components[3].long_name);
            //   }
            // })
          })
        }
      },
      selectMainLevel: function (key) {
        this.selectedMainLevel = key
      },
      disselectMainLevel: function () {
        this.selectedMainLevel = null
      },
      clearInput: function () {
        this.search = ''
        this.searchi18n = ''
        this.filterResults()
      },
      browseServices: function () {
        this.showSpecialities = true
        this.showServices = true
        this.onOpen()
      },
      chooseLanguage (lang) {
        this.language = lang
      }
    },
    directives: {
      'click-outside': {
        bind: function(el, binding, vNode) {
          // Provided expression must evaluate to a function.
          if (typeof binding.value !== 'function') {
            const compName = vNode.context.name
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
            if (compName) { warn += `Found in component '${compName}'` }

            console.warn(warn)
          }
          // Define Handler and cache it on the element
          const bubble = binding.modifiers.bubble
          const handler = (e) => {
            if (bubble || (!el.contains(e.target) && el !== e.target)) {
              binding.value(e)
            }
          }
          el.__vueClickOutside__ = handler

          // add Event Listeners
          document.addEventListener('click', handler)
        },

        unbind: function(el, binding) {
          // Remove Event Listeners
          document.removeEventListener('click', el.__vueClickOutside__)
          el.__vueClickOutside__ = null

        }
      }
    },
    async mounted () {
      try {
        this.getServices({ context: this })
        this.getSpecialities({ context: this })
      } catch (error) {
        console.error(error)
      }
    },
    created () {
      if (!_.isEmpty(this.$route.params)) {
        this.search = this.$route.params.search || ''
        this.searchi18n = this.search
        this.language = this.$route.params.language || ''
        this.trainingMethod = this.$route.params.method || ''
        this.isService = this.$route.params.service || false

        this.submitSearch()

        // Default title
        let siteTitle = `${this.$i18n.t('searchPage.emptySearch')} `

        if (this.searchi18n && this.searchi18n !== '#') {
          siteTitle = `${this.searchi18n} `
        }

        if (this.trainingMethod && this.trainingMethod !== '#') {
          siteTitle += `| ${this.trainingMethod} `
        }
        siteTitle += `| Fine.Fit`

        let siteDesc = this.$i18n.t('searchDesc', { search: this.searchi18n })
        let descEl = document.querySelector('head meta[name="description"]')

        document.title = siteTitle
        descEl.setAttribute('content', siteDesc)

        window.history.pushState({}, document.title, document.location.href)
      }

      if (this.search === '#') {
        this.search = ''
      }

      if (this.searchi18n === '#') {
        this.searchi18n = ''
      }

      if (this.language === '#') {
        this.language = ''
      }

      if (this.trainingMethod === '#') {
        this.trainingMethod = ''
      }
    },
    watch: {
      searchNamesResults: function (val, oldVal) {
        if (!_.isEmpty(val)) {
          console.log(val)
          this.specialitiesResultsi18n = []
        }
      },
      definedSearch: function (val, oldVal) {
        if (val) {
          this.searchi18n = val

          if (this.searchi18n === '#') {
            this.searchi18n = ''
          }
        }
      },
      definedLocation: function (val, oldVal) {
        if (val) {
          this.location = val

          if (this.location === '#') {
            this.location = ''
          }
        }
      },
      language: function (val, oldVal) {
         this.onInput()
      },
      trainingMethod: function (val, oldVal) {
        this.onInput()
      }
    }
  }
</script>

<style lang="scss">
  @import '~assets/styles/app.scss';

  #darkside {
    background: rgba(12,18,28,.6);
    display: block;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9;
    transition: all .7s;
  }
</style>

<style lang="scss" scoped>
  @import '~assets/styles/app.scss';

  #search {
    position: relative;

    &.active {
      @include media-breakpoint-down(sm) {

      }
    }

    &.search-page {
      #training-method {
        .btn.training-method {
          color: #526c8d;
          border-color: #526c8d !important;
          background-color: transparent !important;
          width: auto !important;
          line-height: 1.2rem;

          &:hover {
            background-color: rgba(255, 255, 255, 0.5) !important;
          }

          &.active {
            color: white;
            background-color: #526c8d !important;
          }

          .material-icons {
            font-size: 2rem;
          }

          @include media-breakpoint-down(sm) {
            margin: 0 auto;
            width: 50% !important;
          }
        }

        @include media-breakpoint-down(sm) {
          margin-top: 4rem !important;
        }
      }

      #search-block {
        width: 69%;

        @include media-breakpoint-down(sm) {
          width: 100%;
          margin-top: 1rem;
        }
      }
    }
  }

  #search-input,
  #training-method {
    .wrapper {
      align-items: flex-start;
      flex-wrap: nowrap;
      justify-content: space-between;
    }
    .btn.services-list,
    .btn.btn-clear {
      position: absolute;
      right: 0.1rem;
      top: 0.4rem;
      background: transparent;
      margin: 0;
      padding: 0;
      border: 0;
      text-align: center;
      vertical-align: middle;
      z-index: 99;

      i {
        color: #ccc;
      }

      @include media-breakpoint-down(sm) {
        /*display: none;*/
      }
    }
  }

  #search-input {
    .input-group-append {
      @include media-breakpoint-down(sm) {
        display: none;
      }
    }
  }

  #training-method {
    .btn.training-method {
      border-color: white !important;
      background-color: transparent !important;
      width: auto !important;
      line-height: 1.2rem;

      &:hover {
        background-color: rgba(255,255,255,0.3) !important;
      }

      &.active {
        color: #526c8d;
        background-color: white !important;
      }

      .material-icons {
        font-size: 2rem;
      }

      @include media-breakpoint-down(sm) {
        margin: 0 auto;
        width: 50% !important;
      }
    }
  }

  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    /*display: inline-block;*/
  }

  span.highlight {
    /*background-color: yellow;*/
  }

  ul.suggestions-list {
    word-break: break-word;

    li {
      line-height: 1.2rem;

      @include media-breakpoint-down(sm) {
        font-size: 0.8rem;
      }
    }
  }

  #language-block {
    width: 30%;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }
  }

  #search-block {
    /*position: absolute;*/
    /*background: white;*/
    /*border: 1px solid black;*/
    /*z-index: 999;*/
    width: 100%;

    /*@include media-breakpoint-down(sm) {
      width: 100%;
      margin-top: 1rem;
    }*/
  }

  .search-input-wrapper {
    position: relative;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;

    &.form-control {
      padding: 0;
      border: none;
    }

    @include media-breakpoint-down(sm) {
      flex-direction: column;
    }
  }
  #search-results {
    text-align: left;
    width: 100%;
    max-height: 420px;
    overflow-y: hidden;

    .services,
    .specialities {
      padding: 1rem;
      max-height: 420px;
      overflow-y: scroll;

      .parent,
      .children {
        margin: 0.2rem 0;
      }

      .btn.collapsible {
        .material-icons {
          font-size: 1em;

          &:before {
            content: 'expand_less';
          }
        }

        &.collapsed {
          .material-icons {
            &:before {
              content: 'expand_more';
            }
          }
        }
      }

      .children {
        margin-left: 1rem;
      }
    }

    .results {
      padding: 1rem;
      max-height: 420px;
      overflow-y: scroll;

      a {
        color: black;
        padding-bottom: 1rem;

        .photo-wrapper {
          vertical-align: top;

          img.profile {
            width: 100%;
            height: auto;
            border: 1px solid #ccc;
          }
        }

        .name {
          font-weight: bold;
        }
        .specialities {
          color: #17a2b8;
          font-style: italic;
          padding: 0;
        }
        .locations {
          font-size: 0.8rem;
        }
        .matches {

        }
      }

      @include media-breakpoint-down(sm) {
        max-height: 100%;
        overflow-y: visible;
      }
    }

    @include media-breakpoint-down(sm) {
      max-height: 100%;
      overflow-y: visible;
    }
  }

  section {
    padding: 1rem 0;
  }

  section.thumbs {
    .col {
      padding: 15px;
    }
    a {
      position: relative;
      color: white !important;
      text-transform: uppercase;
      text-decoration: none;

      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid white;
        padding: 0.5rem;
      }
      img {
        width: 100%;
        height: auto;
      }

      &:hover {
        color: white;
        opacity: .9;
      }
    }
  }

  #search-results {
    .services {
      .card {
        border: none;
        border-radius: 0;
      }
      header {
        padding: 0;
        background: transparent;
        border: none;
        border-radius: 0;
      }
      .btn.second-level {
        color: white;
        border: none;
        box-shadow: none;
      }
      .card-body.third-level {
        padding: 0.5rem 0;

        a.third-level {
          display: block;
          color: black;
          padding: 0.5rem 0;
          border-bottom: 1px solid black;
          white-space: normal;
        }
      }
    }
  }

  section#services {
    .row {
      margin-bottom: -30px;
    }
  }

  #professional {
    position: relative;
    min-height: 400px;
    background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(https://images.unsplash.com/photo-1517963628607-235ccdd5476c?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=c688dfbe53dcd3cbf32c3b171adff920&auto=format&fit=crop&w=1502&q=80) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    text-align: center;
    color: white;
    font-size: 1.5rem;

    .container {
      width: 40%;

      h2 {
        margin-top: 6rem;
        text-align: center;
        font-size: 2rem;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  .nav{
    list-style:none;
    margin-left:0;
  }
  .nav > li,
  .nav > li > a{
    display:inline-block;
    *display:inline;
    zoom:1;
  }
  .stacked > li{
    display:list-item;
  }
  .stacked > li > a{
    display:block;
  }


  .flyout, .flyout-alt {
    position: relative;
  }

  .flyout-content {
    position: absolute;
    top: 100%;
    left: -99999px;
    height: 0;
    overflow: hidden;
    z-index: 999;
  }

  .flyout:hover > .flyout-content {
    left: 0;
  }

  .flyout-alt:hover > .flyout-content {
    top: 0;
    left: 100%;
  }

  .flyout:hover > .flyout-content, .flyout-alt:hover > .flyout-content {
    height: auto;
    overflow: visible;
  }

  .search-input-wrapper {
    .btn-browse-services {
      position: absolute;
      right: 0.3rem;
      top: 0.35rem;
      color: #333;
      font-size: 0.7rem;
      padding: 0.3rem;
      border: 1px solid #333;
      background-color: white !important;

      @include media-breakpoint-down(sm) {
        top: 3.7rem;
      }
    }
  }

  ul.services {
    > li {
      width: 50% !important;
      > ul.flyout-content {
        /*position: relative;*/
        /*width: 100%;*/
        left: 100% !important;
        top: 0 !important;
      }
    }
    font-size: 0.8rem;
    font-family: sans-serif;
    li {
      display: block;
      margin: 0;
      width: 100%;
      margin-left: 0.1rem;
    }
    a {
      line-height: 1;
      padding: 1em;
      padding-left: 0;
      background-color: white;
      color: black;
      border-bottom: 2px solid black !important;
      white-space: nowrap;
      i {
        font-size: 0.8rem;
      }
    }
    .flyout:hover > a, .flyout-alt:hover > a,
    a:hover {
      color: white;
      background-color: $primary;
      text-decoration: none;
    }
    .flyout-alt > a:after {
      content: "";
    }
    a {
      border: 0 solid #fff;
    }
    .flyout-content {
      background-color: white;
      a {
        border-bottom-width: 1px;
      }
    }
    > li {
      > a {

      }
      &:first-child > a {
        border: none;
      }
    }
    .flyout-alt:hover > .flyout-content {
      top: -1px;
    }
  }

  .autocomplete {
    position: relative;
    width: 100%;

    #search-services {
      border: none;
      padding-right: 2.5rem;
    }

    @include media-breakpoint-down(sm) {
      position: unset;
    }
  }

  .autocomplete-results {
    position: absolute;
    top: 2.5rem;
    left: 0;
    padding: 0;
    margin: 0;
    height: auto;
    overflow: auto;
    width: 50%;
    z-index: 999;

    &.autocomplete-specialities {
      left: 0;
      width: 80%;

      &.full-width {
        width: 100% !important;

        li {
          display: block;
          width: 100%;
        }

        h6 {
          margin-left: 0.5rem;
          margin-right: 0.5rem;
          text-align: left;

          @include media-breakpoint-down(sm) {
            text-align: center;
          }
        }

        @include media-breakpoint-down(md) {
          width: 100% !important;
          left: 0;
        }
      }

      .btn-browse-services {
        right: 0.5rem;
        top: 0.65rem;

        @include media-breakpoint-down(sm) {
          display: none;
        }
      }

      @include media-breakpoint-down(md) {
        width: calc(50% + 25px);
        left: -50px;
      }

      @include media-breakpoint-down(sm) {
        width: calc(100% + 50px) !important;
      }
    }

    &.autocomplete-services {
      left: 80%;
      width: 120%;

      @include media-breakpoint-down(md) {
        left: calc(50% - 25px);
        width: calc(50% + 25px);
      }
    }

    &.autocomplete-professionals {
      left: 0%;
      width: 100%;

      @include media-breakpoint-down(md) {
        left: -50px;
        width: calc(100% + 50px);
      }

      a {
        color: inherit !important;
      }

      .wrapper {
        @include media-breakpoint-down(md) {
          height: auto;
        }
      }
    }

    .wrapper {
      height: auto;
      max-height: 400px;
      overflow-y: scroll;
      border: 1px solid #eeeeee;
      background: white;

      @include media-breakpoint-down(md) {
        height: calc(100vh - 10rem);
      }
    }

    @include media-breakpoint-down(md) {
      top: 2.5rem;
      font-size: 0.8rem;
    }
  }

  .selected-main-level {
    padding: 0 0.5rem;
    font-size: 0.8rem;
    text-align: left;
    opacity: 0.8;

    div {
      font-weight: bold;
      text-decoration: underline;
    }
  }

  .autocomplete-result {
    width: 100%;
    list-style: none;
    text-align: left;
    padding: 0.3rem 0.5rem;
    cursor: pointer;

    &.main-level {
      color: inherit;
      font-weight: bold;
      white-space: normal;
      padding: 0.7rem 0.5rem;
      border: none;
      border-radius: 0;
      border-bottom: 2px solid black;
      text-align: left;
      box-shadow: none;
      background: transparent;

      i {
        position: absolute;
        margin-top: -3px;
      }

      @include media-breakpoint-down(sm) {
        font-size: 0.8rem;
      }
    }
  }

  .autocomplete-result.is-active,
  .autocomplete-result:hover {
    background-color: #4aae9b;
    color: white;
  }

  #services-list {
    .card {
      border: none;
      border-radius: 0;
    }
    header {
      padding: 0;
      background: transparent;
      border: none;
      border-radius: 0;
    }
    .btn.main-level {
      color: inherit;
      white-space: normal;
      border: none;
      border-radius: 0;
      border-bottom: 2px solid black;
      text-align: left;
      box-shadow: none;
      background: transparent;
    }
    .btn.second-level {
      color: white;
      border: none;
      box-shadow: none;
    }
    .card-body.third-level {
      padding: 0.5rem 0;

      a.third-level {
        display: block;
        color: black;
        padding: 0.5rem 0;
        border-bottom: 1px solid black;
        white-space: normal;
      }
    }

    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  .input-group-prepend {
    margin-right: 0;

    .input-group-text {
      border-radius: 0;
      border-right-color: transparent;
    }
  }

  #location-input {
    .input-group {
      @include media-breakpoint-down(sm) {
        /*margin-top: 0;*/
      }
    }
  }

  .btn-cta {
    font-size: 18px !important;
    background-color: #6ecdff !important;
  }

  .btn-back {
    position: relative;
    width: 100%;
    white-space: normal;

    i {
      position: absolute;
      left: 0.2rem;
      top: 50%;
      transform: translateY(-50%);
      margin-left: 0;
      margin-right: 0;
    }

    span {
      padding-left: 0.7rem;
    }

    @include media-breakpoint-down(sm) {
      font-size: 0.8rem;
    }
  }

  .btn-close {
    display: none;
    color: black !important;
    background-color: white !important;

    @include media-breakpoint-down(sm) {
      display: block;
      position: absolute;
      top: -2.1rem;
      right: -3.2rem;
      transform: translateX(-50%);
      z-index: 999;
      color: white;
      font-size: 1.2rem;
      text-align: center;
      border: none;

      i {
        margin-top: -0.2rem;
        margin-left: -0.2rem;
        margin-right: 0;
      }
    }
  }
</style>
